// extracted by mini-css-extract-plugin
export default {"force":"Force_force__Hgq09","range":"Force_range__iNQEV","handler":"Force_handler__K8UjA","button":"Force_button__sJdAI","active":"Force_active__+2eiF"};